module.exports = __webpack_public_path__ + "static/media/reordenar_cima.bf8048d8.svg";